export default __webpack_public_path__ + "assets/MyriadPro-Cond.6e177fd5.svg";